import { NotificationCircle } from "@medoma/components/NotificationCircle/NotificationCircle";
import styles from "./IconWithIndicator.module.scss";
import clsx from "clsx";

type IconWithIndicatorProps = {
  icon: React.ReactNode;
  indicatorIsActive: boolean;
  number?: number;
  passiveState?: "hidden" | "visible";
};

const IconWithIndicator = ({
  icon,
  indicatorIsActive,
  number,
  passiveState = "hidden",
}: IconWithIndicatorProps) => {
  if (passiveState === "hidden" && !indicatorIsActive) {
    return null;
  }

  return (
    <div className={clsx([indicatorIsActive ? styles.active : styles.passive])}>
      <NotificationCircle
        isVisible={indicatorIsActive}
        placement="top-left"
        number={number}
      >
        {icon}
      </NotificationCircle>
    </div>
  );
};

export default IconWithIndicator;
